import { render, staticRenderFns } from "./MessageIntermediateCatchEvent.vue?vue&type=template&id=753875ea&scoped=true&"
import script from "./MessageIntermediateCatchEvent.vue?vue&type=script&lang=js&"
export * from "./MessageIntermediateCatchEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753875ea",
  null
  
)

export default component.exports